import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from '@pella/sash-framework';
import { Image } from '../../../';

const ScreensPanel = ({ data }) => {
	return (
		<div className='screensPanel'>
			{data?.heading && <h3 className='text-center'>{data.heading}</h3>}

			{data?.card?.[0] && (
				<Row
					className='text-center'
					justify='center'
					verticalGutters
				>
					{data.card.map((card, index) => (
						<Column
							key={index}
							xs={12}
							sm={6}
							lg={4}
						>
							{card.image?.[0] && (
								<Image
									data={card.image[0]}
									className='mx-auto mb-4 !block'
								/>
							)}

							{card.heading && <div dangerouslySetInnerHTML={{ __html: card.heading }} />}
							{card.description && <div dangerouslySetInnerHTML={{ __html: card.description }} />}
						</Column>
					))}
				</Row>
			)}
		</div>
	);
};

ScreensPanel.propTypes = {
	data: PropTypes.object.isRequired,
};

export default ScreensPanel;
